import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import withTheme from 'core/hocs/withTheme';

import themePropTypes from 'core/utils/prop-types/theme';

import isNotEmptyReactElementContent from 'core/utils/content';
import { resolveScopedStyles } from 'core/utils/styled-jsx';

const levelToStyles = {
  1: 'title1',
  2: 'title2',
  3: 'title3',
  4: 'title4',
  5: 'title5',
  6: 'title6',
};


function Heading(props) {
  const {
    level,
    children,
    theme,
    className,
    is,
    id,
    dataQa,
  } = props;

  if (isNotEmptyReactElementContent(children)) {
    const textAtoms = theme.texts[levelToStyles[level]];
    const {
      font = textAtoms.font,
      color = textAtoms.color,
      letterSpacing,
    } = textAtoms;

    const scope = resolveScopedStyles(
      <scope>
        <style jsx>{`
          .heading
            margin 0
            padding 0
        `}</style>
        <style jsx>{`
          .heading
            font ${font}
            color ${color}
        `}</style>
      </scope>
    );

    const scopeLetterSpacing = letterSpacing
      ? resolveScopedStyles(
        <scope>
          <style jsx>{`
            .letterSpacing
              letter-spacing ${letterSpacing}
          `}</style>
        </scope>
      ) : null;

    const classNames = [
      scope.wrapClassNames('heading'),
      scopeLetterSpacing && scopeLetterSpacing.wrapClassNames('letterSpacing'),
      className,
    ].filter(Boolean);
    const tag = `h${level}`;
    const headerProps = {
      className: classNames.join(' '),
    };

    if (id) headerProps.id = id;
    if (dataQa) headerProps['data-qa'] = dataQa;

    return (
      <Fragment>
        {React.createElement(is || tag, headerProps, children)}
        <scope.styles />
      </Fragment>
    );
  }

  return null;
}

const styleContract = `
  {
    font,
    color,
  }
`;

Heading.propTypes = {
  /** @ignore */
  children: PropTypes.node,
  /** @ignore */
  className: PropTypes.string,
  /**
  * В некоторых случаях требуется чтобы компонент выглядел,
  * как заголовок(h1-h6), но не являлся им по-сути.
  * С помощью параметра is можем передать нужный нам тег(div).
  * */
  is: PropTypes.string,
  /**
   * Уровень отображаемого заголовка
   */
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]).isRequired,
  /** @ignore */
  theme: themePropTypes(`
    {
      texts: {
        headline: ${styleContract},
        title2: ${styleContract},
        title3: ${styleContract},
        title4: ${styleContract},
        title5: ${styleContract},
        title6: ${styleContract},
      },
    }
  `),
  /** @ignore */
  id: PropTypes.string,
  /** @ignore */
  dataQa: PropTypes.string,
};

Heading.defaultProps = {
  level: 1,
};

const HeadingWithHOCs = withTheme(Heading);
HeadingWithHOCs.displayName = 'Heading';

export { Heading as StorybookComponent };
export default HeadingWithHOCs;
